import React, { Component, Fragment } from "react";
import WorkSpaceHeader from "./WorkSpaceHeader";
import WorkSpaceDescription from "./WorkSpaceDescription";
import WorkSpaceFreelancers from "./WorkSpaceFreelancers";
import Header from "../account/Header";
import { getLink } from "../../../services/employerJobListing";
import Waiting from "./../../utilities/Waiting";
import AppContext from "../../../contexts/AppContext";

export class WorkSpace extends Component {
    state = {
        waiting: true,
        activeTab: "description",
        job: { user: {}, industry: {}, category: {}, type: {}, duration: {} },
    };
    setActiveTab = tabName => {
        this.setState({ activeTab: tabName });
    };
    componentDidMount() {
        getLink(this.props.match.params["link"])
            .then(res => {
                this.setState({ job: res.data, waiting: false });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    }
    render() {
        return (
            <Fragment>
                {this.state.waiting === true ? (
                    <Waiting></Waiting>
                ) : (
                    <Fragment>
                        <Header></Header>
                        <WorkSpaceHeader
                            activeTab={this.state.activeTab}
                            setActiveTab={this.setActiveTab}
                            job={this.state.job}
                        ></WorkSpaceHeader>
                        {this.state.activeTab === "description" ? (
                            <WorkSpaceDescription
                                job={this.state.job}
                            ></WorkSpaceDescription>
                        ) : (
                            <WorkSpaceFreelancers
                                match={this.props.match}
                                job={this.state.job}
                            ></WorkSpaceFreelancers>
                        )}
                    </Fragment>
                )}
            </Fragment>
        );
    }
}
WorkSpace.contextType = AppContext;
export default WorkSpace;



// WEBPACK FOOTER //
// ./src/components/employer/workSpace/WorkSpace.js